import { Factory } from '../../services/Factory';

namespace app.controllers.mfa {

  interface IMFAModalControllerScope extends angular.IScope {
    account;
    loginMode: boolean;
    closeModal: Function;
    enableMFA: Function;
    saving: boolean;
  }

  export class MFAModalController {
    constructor($scope: IMFAModalControllerScope, $modalInstance, account, accountService: app.services.account.AccountService) {
      $scope.closeModal = () => {
        $modalInstance.close();
      };

      $scope.enableMFA = () => {
        $scope.saving = true;

        accountService.Update($scope.account, () => {
          // Good, Try to enable MFA
          accountService.RegisterMFA(() => {
            // Good, give back success message
            $modalInstance.close(true);
            $scope.saving = false;
          }, () => {
            $scope.saving = false;
          });

        }, e => {
          // Bad
          console.error(e);
        });
      };

      $scope.registerMFA = () => {
        accountService.RegisterMFAForLogin($scope.email, $scope.token, $scope.account.phone, () => {
        }, () => {
        });

        $scope.step = 2;
      };

      $scope.verifyMFA = () => {
        $scope.saving = true;

        accountService.VerifyMFAForLogin($scope.email, $scope.password, $scope.token, $scope.account.verificationCode, () => {
          // Good, give back success message
          $modalInstance.close(true);
          $scope.saving = false;
          $scope.account.verificationCode = "";
        }, () => {
          $scope.saving = false;
          $scope.account.verificationCode = "";
        });
      };

    }
  }

  frontendApp.controller("MFAModalController", ["$scope", "$uibModalInstance", "account", "AccountService", "NotificationService", Factory.Create(MFAModalController)]);
}
